import React from 'react';
import { Box, Stack, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import { Bar, BarChart, CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import type { UsagePoint } from '../../types/usage';
import { formatTokens, formatUsd } from '../../services/usage.service';

interface Props { points: UsagePoint[]; mode: 'tokens' | 'usd'; onModeChange: (m: 'tokens' | 'usd') => void }

export const UsageChart: React.FC<Props> = ({ points, mode, onModeChange }) => (
  <Box>
    <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 1 }}>
      <Typography variant="subtitle1">Daily usage</Typography>
      <ToggleButtonGroup size="small" exclusive value={mode} onChange={(_, m) => m && onModeChange(m)}>
        <ToggleButton value="tokens">Tokens</ToggleButton>
        <ToggleButton value="usd">USD</ToggleButton>
      </ToggleButtonGroup>
    </Stack>
    {points.length === 0 ? (
      <Typography color="text.secondary" sx={{ py: 6, textAlign: 'center' }}>No usage in this range.</Typography>
    ) : (
      <Box sx={{ width: '100%', height: 280 }} data-testid="usage-chart">
        <ResponsiveContainer>
          {mode === 'tokens' ? (
            <BarChart data={points}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="date" />
              <YAxis tickFormatter={(v) => formatTokens(Number(v))} />
              <Tooltip formatter={(v) => formatTokens(Number(v))} />
              <Legend />
              <Bar dataKey="input" stackId="t" name="Input" fill="#059669" />
              <Bar dataKey="output" stackId="t" name="Output" fill="#6366f1" />
              <Bar dataKey="cache_read" stackId="t" name="Cache read" fill="#34d399" />
              <Bar dataKey="cache_creation" stackId="t" name="Cache write" fill="#818cf8" />
            </BarChart>
          ) : (
            <LineChart data={points}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="date" />
              <YAxis tickFormatter={(v) => formatUsd(Number(v))} />
              <Tooltip formatter={(v) => formatUsd(Number(v))} />
              <Line type="monotone" dataKey="cost_usd" name="USD" stroke="#059669" dot={false} />
            </LineChart>
          )}
        </ResponsiveContainer>
      </Box>
    )}
  </Box>
);

export default UsageChart;
